// Gameplay tuning constants that stay in code.
//
// Values that the client/designer wants to retune without rebuilding live in
// BE_side/app/character_layout.json instead (item radius/visualSize, character
// collider, gravity, spawn timing, play duration). Everything else is here.
//
// Doc: docs/gameplay-config.md.

// --- Spawn (parts not in the JSON) ---
// Hazard-vs-ingredient mix at spawn.
export const HAZARD_PROBABILITY = 0.3;
// Reject candidate spawn X if it would collide with any item currently in the
// top band of the scene.
export const SPAWN_NO_OVERLAP = true;

// --- Scoring ---
export const SCORE_PER_INGREDIENT = 1;
export const SCORE_PER_HAZARD = -1;
export const SCORE_FLOOR = 0;

// --- Character animation ---
export const BODY_ANIM_FPS = 12;
export const BODY_ANIM_FREEZE_FRAME = 0;
export const HEAD_EMOTION_DURATION_S = 0.5;
export const HEAD_EMOTION_INTERRUPT = true;
export const CHARACTER_FOLLOW_LERP = 0.25;
// Uniform scale applied to the CUSTOM (captured-photo) head sprite at draw time
// (head only, not body/cup) so the player's face reads a touch bigger, matching
// the chibi head ratio (client request). 1.0 = no change; 1.05 = 5% larger.
// Default-icon heads are exempt (drawn at 1.0). Applied at every head-draw site
// (game, capture preview, static theme preview). Replaced the old horizontal
// squash, which the client disliked.
export const HEAD_CUSTOM_SCALE = 1.05;

// --- Particles ---
export const PARTICLE_BASE_SIZE = 160; // scene units; particle scale=1.0 yields this edge
export const PARTICLE_COUNT_MIN = 3;
export const PARTICLE_COUNT_MAX = 5;
export const PARTICLE_DURATION_S = 0.25;
export const PARTICLE_SCALE_FROM = 0.25;
export const PARTICLE_SCALE_TO = 1.0;
export const PARTICLE_SPREAD_SPEED = 400;
export const PARTICLE_FADE_CURVE: "linear" = "linear";

// --- Audio ---
export const BGM_VOLUME = 0.5;
export const SFX_VOLUME = 0.8;
export const BGM_FADE_IN_S = 0.3;
export const BGM_FADE_OUT_S = 0.3;

// --- Countdown UI ---
export const COUNTDOWN_POSITION: "top-center" = "top-center";
export const COUNTDOWN_WARNING_AT_S = 3;
